// extracted by mini-css-extract-plugin
module.exports = {"TemperatureWrapper":"Temperature_TemperatureWrapper__LS-sZ","TemperatureSymbol":"Temperature_TemperatureSymbol__16-qn"};